import { Button, Collapse, CollapseProps } from "antd";
import React from "react";
import { ChevronDownIcon, ChevronUpIcon } from "../../../assets/svg";
import CheckList from "./components/CheckList";

// TODO: This component should be written exactly like src/app/organism/Notes/Notes.tsx component for consistency
export const Checklist = () => {
  const renderExpandIcon: CollapseProps["expandIcon"] = ({ isActive }) => (
    <Button
      type="text"
      style={{ borderRadius: 6, width: "1.5rem", display: "grid", justifyContent: "center", alignItems: "center" }}
    >
      {isActive ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Button>
  );

  return (
    <Collapse
      className="ds-collapse"
      defaultActiveKey="checklist"
      expandIconPosition="end"
      collapsible="icon"
      expandIcon={renderExpandIcon}
      style={{ backgroundColor: "white", maxWidth: "28.5rem" }}
    >
      <Collapse.Panel
        header={<span style={{ fontWeight: 700, color: "var(--blue-600)", fontSize: "1.125rem" }}>Checklist</span>}
        key="checklist"
      >
        <div style={{ minHeight: "26rem" }}>
          <CheckList isVisible />
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};
